export const HELP_REQUEST_EMAIL = 'alss.alacapacity@gov.ab.ca';

export const HELP_REQUEST_SUBJECT = 'Capacity reporting request';

export const HELP_REQUEST_DETAIL_PROMPTS = [
  'Your name',
  'Facility name',
  'Facility address',
  'Describe your issue',
] as const;

/**
 * Builds the URL-encoded body containing the help request prompts, each
 * followed by a colon and separated by blank lines.
 */
export function buildHelpRequestEmailPrompts(
  prompts: readonly string[] = HELP_REQUEST_DETAIL_PROMPTS
): string {
  const promptTail = '%3A%20';
  const eol = '%0D%0A%0D%0A';
  return `${prompts
    .join(`${promptTail}${eol}`)
    .replace(/ /g, '%20')}${promptTail}`;
}

/**
 * Builds the full `mailto:` href used by the help pages to open a pre-filled
 * capacity reporting support email.
 */
export function buildHelpRequestMailtoHref(
  prompts: readonly string[] = HELP_REQUEST_DETAIL_PROMPTS
): string {
  const subject = HELP_REQUEST_SUBJECT.replace(/ /g, '%20');
  return `mailto:${HELP_REQUEST_EMAIL}?subject=${subject}&body=${buildHelpRequestEmailPrompts(
    prompts
  )}`;
}
